import React from 'react';
import AdminLayout from '../../../components/AdminLayout/AdminLayout';
import DashboardMainContainer from '../../../components/common/Containers/DashboardMainContainer';
import {
  AdminPageTitle,
  AdminSupportingText,
  ADMIN_TABLE_CLASS,
} from './adminUx';

/** Placeholder shell for admin pages until feature UI is built */
const AdminEmptyPage = ({ title }) => (
  <AdminLayout>
    <div className="min-w-0">
      <AdminPageTitle>{title}</AdminPageTitle>
      <DashboardMainContainer className={`${ADMIN_TABLE_CLASS} max-w-full min-w-0`}>
        <AdminSupportingText className="text-mediumgray">
          Content for {title} will appear here.
        </AdminSupportingText>
      </DashboardMainContainer>
    </div>
  </AdminLayout>
);

export default AdminEmptyPage;
